export default __webpack_public_path__ + "static/media/FlexibleContent.b7260ac0.jpg";